import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useContainerCoords} from "components/hooks/useContainerCoords.js"
import {connect} from 'react-redux';

const SubPatchSize = ({subpatch, fill}) => { 
    let ref= useRef(undefined);

    let [resizing, setResizing] = useState(false);
    let {getXY} = useContainerCoords({containerRef: ref});

    let {zObject} = subpatch;
    let [size, setSize] = useState(
        zObject.width > 0 ? {
            width: zObject.width,
            height: zObject.height
        } :
        {
            width: 300,
            height: 200,
        });

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [setSize, resizing, setResizing]);

    const onMouseUp = useCallback(() => {
        if (resizing) {
            setResizing(false);
        }
    }, [setResizing, resizing]);

    const onMouseMove = useCallback((e) => {
        if (!resizing) {
            return false;
        }
        let {x,y} = getXY(e);
        subpatch.zObject.width = x;
        subpatch.zObject.height = y;
        setSize({width: x, height: y});
    }, [setSize, resizing]);

    let style = {
        ... size
    };
    if (fill) {
        style.backgroundColor = fill;
    }

    return (
        <div
          ref={ref} style={style} className="sub-patch-size">
          <div onMouseDown={(e) => {
              // e.stopPropagation();
              setResizing(true);
          }} className="right-bottom-corner"/>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      fill: props.subpatch.zObject.attributes["primary-color"]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubPatchSize);
